import { motion } from "framer-motion";
import { LucideIcon, Lightbulb } from "lucide-react";

interface SeoHighlightBoxProps {
  children: React.ReactNode;
  icon?: LucideIcon;
  variant?: "info" | "tip" | "quote";
}

export const SeoHighlightBox = ({ children, icon: Icon = Lightbulb, variant = "tip" }: SeoHighlightBoxProps) => {
  const styles = {
    info: "bg-blue-50 border-blue-200 text-blue-900",
    tip: "bg-brand-purple/5 border-brand-purple/20 text-primary",
    quote: "bg-muted/50 border-l-4 border-brand-purple text-primary italic",
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -10 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      className={`p-5 rounded-xl border ${styles[variant]} flex gap-4 items-start`}
    >
      {variant !== "quote" && (
        <div className="p-2 rounded-lg bg-white/80 shrink-0">
          <Icon className="w-5 h-5 text-brand-purple" />
        </div>
      )}
      <div className="text-sm leading-relaxed">{children}</div>
    </motion.div>
  );
};
